import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';
const ax  = axios.create({ baseURL: API, withCredentials: true });

export default function AccessSection({ currentUserUid }) {
  const [users,    setUsers]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [creating, setCreating] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [form,     setForm]     = useState({ name:'', email:'', password:'', role:'client' });
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState('');

  useEffect(() => { loadUsers(); }, []);

  async function loadUsers() {
    setLoading(true);
    try {
      const { data } = await ax.get('/api/auth/users');
      setUsers(data);
    } catch { setUsers([]); }
    finally { setLoading(false); }
  }

  async function createUser() {
    setError(''); setSuccess('');
    if (!form.email || !form.password) { setError('Courriel et mot de passe requis'); return; }
    if (form.password.length < 6) { setError('Mot de passe : minimum 6 caractères'); return; }
    setCreating(true);
    try {
      await ax.post('/api/auth/signup', form);
      setSuccess(`✅ Compte créé pour ${form.email}`);
      setForm({ name:'', email:'', password:'', role:'client' });
      loadUsers();
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally { setCreating(false); }
  }

  async function removeUser(uid, email) {
    if (!window.confirm(`Supprimer le compte de ${email} ? Cette action est irréversible.`)) return;
    setDeleting(uid);
    try {
      await ax.delete(`/api/auth/users/${uid}`);
      setUsers(prev => prev.filter(u => u.uid !== uid));
    } catch (e) {
      alert('Erreur : ' + (e.response?.data?.error || e.message));
    } finally { setDeleting(null); }
  }

  const inp = {
    background:'#0a0a0d', border:'1px solid rgba(255,255,255,0.08)',
    borderRadius:9, padding:'11px 14px', color:'#EAEAEA',
    fontSize:'0.87rem', outline:'none', width:'100%', boxSizing:'border-box',
  };

  return (
    <div style={{ padding:32, maxWidth:860 }}>

      {/* Header */}
      <div style={{ marginBottom:30 }}>
        <div style={{ fontSize:'0.65rem', color:'#333', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>Administration</div>
        <h1 style={{ fontSize:'2rem', fontWeight:900, color:'#EAEAEA', letterSpacing:'-0.04em', margin:0 }}>Gestion des accès</h1>
        <p style={{ color:'#3a3a3a', fontSize:'0.84rem', margin:'6px 0 0' }}>
          Seul l'administrateur peut créer ou supprimer des comptes utilisateurs.
        </p>
      </div>

      {/* Formulaire création */}
      <div style={{ background:'#0d0d10', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, padding:26, marginBottom:24 }}>
        <div style={{ fontSize:'0.7rem', color:'#555', fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:18 }}>
          Créer un nouvel accès
        </div>

        {error   && <div style={{ background:'rgba(248,113,113,0.08)', border:'1px solid rgba(248,113,113,0.2)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:'0.82rem', marginBottom:14 }}>{error}</div>}
        {success && <div style={{ background:'rgba(74,222,128,0.07)', border:'1px solid rgba(74,222,128,0.2)', borderRadius:8, padding:'10px 14px', color:'#4ade80', fontSize:'0.82rem', marginBottom:14 }}>{success}</div>}

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
          <div>
            <div style={{ fontSize:'0.65rem', color:'#444', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:7 }}>Nom complet</div>
            <input style={inp} type="text" placeholder="Jean Tremblay"
              value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
          </div>
          <div>
            <div style={{ fontSize:'0.65rem', color:'#444', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:7 }}>Courriel</div>
            <input style={inp} type="email" placeholder="client@exemple.com"
              value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
          </div>
          <div>
            <div style={{ fontSize:'0.65rem', color:'#444', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:7 }}>Mot de passe temporaire</div>
            <input style={inp} type="text" placeholder="min. 6 caractères"
              value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} />
          </div>
          <div>
            <div style={{ fontSize:'0.65rem', color:'#444', fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:7 }}>Rôle</div>
            <select style={{ ...inp, cursor:'pointer' }}
              value={form.role} onChange={e => setForm(p => ({ ...p, role: e.target.value }))}>
              <option value="client">Client — accès espace client</option>
              <option value="admin">Admin — accès complet</option>
            </select>
          </div>
        </div>

        <button onClick={createUser} disabled={creating}
          style={{ background: creating ? '#111' : '#C8FF00', color: creating ? '#333' : '#000',
            border:'none', borderRadius:10, padding:'13px 28px', fontWeight:800,
            fontSize:'0.88rem', cursor: creating ? 'default' : 'pointer', transition:'all 0.15s' }}>
          {creating ? '⏳ Création...' : '➕ Créer le compte'}
        </button>
      </div>

      {/* Liste des utilisateurs */}
      <div style={{ background:'#0d0d10', border:'1px solid rgba(255,255,255,0.07)', borderRadius:16, overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid rgba(255,255,255,0.05)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div style={{ fontSize:'0.7rem', color:'#555', fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase' }}>
            Utilisateurs ({users.length})
          </div>
          <button onClick={loadUsers} style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.07)', color:'#444', padding:'4px 12px', borderRadius:6, cursor:'pointer', fontSize:'0.72rem' }}>
            ↺ Actualiser
          </button>
        </div>

        {loading ? (
          <div style={{ padding:'32px', textAlign:'center', color:'#333', fontSize:'0.85rem' }}>Chargement...</div>
        ) : users.length === 0 ? (
          <div style={{ padding:'32px', textAlign:'center', color:'#333', fontSize:'0.85rem' }}>Aucun utilisateur trouvé</div>
        ) : (
          <div>
            {users.map((u, i) => {
              const isMe = u.uid === currentUserUid;
              const isAdmin = u.role === 'admin';
              return (
                <div key={u.uid} style={{
                  display:'flex', alignItems:'center', gap:14, padding:'14px 22px',
                  borderBottom: i < users.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none',
                }}>
                  {/* Avatar */}
                  <div style={{ width:36, height:36, borderRadius:'50%', flexShrink:0,
                    background: isAdmin ? 'rgba(200,255,0,0.1)' : 'rgba(99,179,237,0.1)',
                    border:`1px solid ${isAdmin ? 'rgba(200,255,0,0.25)' : 'rgba(99,179,237,0.2)'}`,
                    display:'flex', alignItems:'center', justifyContent:'center',
                    color: isAdmin ? '#C8FF00' : '#63b3ed', fontWeight:800, fontSize:'0.85rem' }}>
                    {(u.name || u.email || '?')[0].toUpperCase()}
                  </div>

                  {/* Infos */}
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
                      <span style={{ color:'#EAEAEA', fontWeight:700, fontSize:'0.88rem' }}>
                        {u.name || '—'}
                      </span>
                      {isMe && <span style={{ background:'rgba(200,255,0,0.08)', border:'1px solid rgba(200,255,0,0.2)', color:'#C8FF00', fontSize:'0.6rem', fontWeight:800, padding:'1px 7px', borderRadius:4, letterSpacing:'0.06em' }}>VOUS</span>}
                    </div>
                    <div style={{ color:'#444', fontSize:'0.78rem' }}>{u.email}</div>
                  </div>

                  {/* Rôle */}
                  <span style={{
                    background: isAdmin ? 'rgba(200,255,0,0.07)' : 'rgba(99,179,237,0.07)',
                    border:`1px solid ${isAdmin ? 'rgba(200,255,0,0.2)' : 'rgba(99,179,237,0.15)'}`,
                    color: isAdmin ? '#C8FF00' : '#63b3ed',
                    fontSize:'0.68rem', fontWeight:800, padding:'3px 10px', borderRadius:5,
                    textTransform:'uppercase', letterSpacing:'0.06em', flexShrink:0,
                  }}>
                    {isAdmin ? '👑 Admin' : '👤 Client'}
                  </span>

                  {/* Date */}
                  {u.createdAt && (
                    <span style={{ color:'#2a2a2a', fontSize:'0.72rem', flexShrink:0 }}>
                      {new Date(u.createdAt).toLocaleDateString('fr-CA')}
                    </span>
                  )}

                  {/* Supprimer */}
                  {!isMe && (
                    <button onClick={() => removeUser(u.uid, u.email)}
                      disabled={deleting === u.uid}
                      style={{ background:'transparent', border:'1px solid rgba(248,113,113,0.2)',
                        color: deleting === u.uid ? '#333' : '#f87171cc',
                        padding:'5px 11px', borderRadius:6, cursor:'pointer',
                        fontSize:'0.72rem', flexShrink:0, transition:'all 0.15s' }}>
                      {deleting === u.uid ? '⏳' : '🗑 Supprimer'}
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
